import { render, staticRenderFns } from "./ProviderFilterDropdown.vue?vue&type=template&id=676bb3dc&"
import script from "./ProviderFilterDropdown.vue?vue&type=script&lang=js&"
export * from "./ProviderFilterDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports